import { ApplicationConfig } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideNativeDateAdapter } from '@angular/material/core';
import './shared/chart-setup';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import {
  provideKeycloak,
  includeBearerTokenInterceptor,
  createInterceptorCondition,
  IncludeBearerTokenCondition,
  INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
} from 'keycloak-angular';
import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { authErrorInterceptor } from '@core/interceptors/auth-error-interceptor';
import { httpErrorInterceptor } from '@core/interceptors/http-error-interceptor';
import { provideLoadingBarInterceptor } from '@ngx-loading-bar/http-client';
import { provideLoadingBarRouter } from '@ngx-loading-bar/router';

const comesaCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
  urlPattern: new RegExp(`^${environment.api.comesa.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}(/.*)?$`, 'i'),
  bearerPrefix: 'Bearer',
});

const coreCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
  urlPattern: new RegExp(`^${environment.api.core.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}(/.*)?$`, 'i'),
  bearerPrefix: 'Bearer',
});

const rawsurCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
  urlPattern: new RegExp(`^${environment.api.rawsur.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}(/.*)?$`, 'i'),
  bearerPrefix: 'Bearer',
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withComponentInputBinding()),
    provideNativeDateAdapter(),
    provideAnimationsAsync(),
    provideHttpClient(
      withInterceptors([includeBearerTokenInterceptor, authErrorInterceptor, httpErrorInterceptor]),
      withInterceptorsFromDi(),
    ),
    provideKeycloak({
      config: {
        url: environment.keycloak.url,
        realm: environment.keycloak.realm,
        clientId: environment.keycloak.clientId,
      },
      initOptions: {
        onLoad: 'check-sso',
        silentCheckSsoRedirectUri: window.location.origin + '/assets/silent-check-sso.html',
        checkLoginIframe: false,
      },
    }),
    {
      provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
      useValue: [comesaCondition, coreCondition, rawsurCondition],
    },
    provideLoadingBarInterceptor(),
    provideLoadingBarRouter()
  ],
};
